import React, { useEffect, memo } from 'react';
import { bool, element, node, string } from 'prop-types';
import { DSModalSlide } from '@elliemae/ds-modal-slide';

export const ModalSlide = ({
  isOpen = false,
  header = null,
  footer = null,
  children,
  maxWidth = null,
}) => {
  const rootElement = document.getElementById('root') as HTMLElement;

  const changeModalWidth = () => {
    const modalContent = rootElement?.querySelector(
      '.em-ds-modal-slide__content',
    ) as HTMLElement;
    if (modalContent) {
      modalContent.style.maxWidth = maxWidth || '552px';
    }
  };

  // useEffect(() => {
  //   const rootContainer =
  //     document.querySelector<HTMLElement>('.root-container');
  //   if (rootContainer) {
  //     if (isOpen) {
  //       rootContainer.style.cssText += 'overflow-y: hidden';
  //     } else {
  //       rootContainer.style.removeProperty('overflow-y');
  //     }
  //   }
  //   return () => {
  //     if (rootContainer) {
  //       rootContainer.style.removeProperty('overflow-y');
  //     }
  //   };
  // }, [isOpen]);

  return (
    <div>{isOpen ? 'The modal slide' : ''}</div>
    // <DSModalSlide
    //   fadeIn={300}
    //   fadeOut={100}
    //   fullWidth={false}
    //   getContainer={() => {
    //     changeModalWidth();
    //     return rootElement;
    //   }}
    //   isOpen={isOpen}
    //   header={header}
    //   footer={footer}
    //   data-testid="ModalSlide-all-components"
    // >
    //   {children}
    // </DSModalSlide>
  );
};

ModalSlide.propTypes = {
  isOpen: bool,
  header: element,
  footer: element,
  children: node,
  maxWidth: string,
};
